import formatDateWithTimezone from "@insite/client-framework/Common/Utilities/formatDateWithTimezone";
import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/PlaceOrderForApproval";


const convertDateToApiFormat = (date: Date | null) => (date ? formatDateWithTimezone(date) : "");

replaceInChain(chain, PopulateApiParameter, props=>{
    const state = props.getState();
    const {
        pages: {
            onePageCheckout: { cartId, requestedDeliveryDate, requestedPickupDate, editedCartNotes },
        },
    } = state;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;

    if (!cart) {
        throw new Error("There was no current cart and we are trying to place the current cart as an order.");
    }

    const tempDeliveryDate =
        typeof requestedDeliveryDate !== "undefined" ? requestedDeliveryDate : cart.requestedDeliveryDateDisplay;
    const tempPickupDate =
        typeof requestedPickupDate !== "undefined" ? requestedPickupDate : cart.requestedPickupDateDisplay;

    const notes = typeof editedCartNotes === "undefined" ? cart.notes : editedCartNotes;

    props.apiParameter = {
        cart: {
            ...cart,
            status: "AwaitingApproval",
            requestedDeliveryDate: convertDateToApiFormat(tempDeliveryDate),
            requestedPickupDate: convertDateToApiFormat(tempPickupDate),
            notes,
        },
    };
})
